<template>
  <form class="new column" @submit="save()" autocomplete="off">
    <div class="title grid-12">
      Nova
      <strong>Solicitação</strong>
    </div>

    <div class="data column label">
      <div class="sla">Dados do Job</div>
      <div class="row-g column">
        <div class="grid-2-g grid-12 column">
          Cliente
          <br />
          <AutoComplete
            :list="clients"
            @value="(item) => (job.id_cliente = item.id)"
            :name="'nome_cliente'"
            :required="true"
          />
        </div>
        <div class="grid-3 grid-12-s column">
          Urgência
          <br />
          <select v-model="job.urgencia_atendimento" required>
            <option value>Selecione</option>
            <option value="imediato">Atendimento Imediato (Até 1 hora)</option>
            <option value="agendado">Atendimento Agendado</option>
          </select>
        </div>
        <div
          class="grid-2-g grid-12 column"
          v-if="job.urgencia_atendimento === 'agendado'"
        >
          Agendamento
          <br />
          <div class="row grid-12">
            <input
              class="grid-8"
              type="date"
              v-model="dh_agendamento_cliente_data"
              :readonly="job.urgencia_atendimento === 'imediato'"
              required
            />
            &nbsp;
            <input
              class="grid-4"
              type="time"
              v-model="dh_agendamento_cliente_hora"
              :readonly="job.urgencia_atendimento === 'imediato'"
              required
            />
          </div>
        </div>
        <div class="grid-2-g grid-12 column">
          Cód. Venda
          <br />
          <input type="text" v-model="job.codigo_venda" />
        </div>

        <div class="grid-2-g grid-12 column">
          Chamado Cliente
          <br />
          <input
            type="text"
            v-model="job.codigo_chamado_cliente"
            @change="verify_client_cod()"
          />
        </div>
        <div class="grid-6-g grid-12 column" v-if="job.codigo_duplicado">
          Motivo código do cliente duplicado
          <br />
          <input type="text" v-model="job.motivo_codigo_duplicado" required />
        </div>
      </div>
    </div>

    <div class="data column label">
      <div class="sla">Local de atendimento</div>
      <div class="row-g column">
        <div class="grid-3-g grid-12 column">
          Nome no local de atendimento
          <br />
          <input type="text" v-model="job.nome_local_atendimento" required />
        </div>
        <div class="grid-1-g grid-12 column">
          CEP
          <br />
          <input
            type="text"
            v-model="job.cep"
            @input="cep()"
            v-mask="'##.###-###'"
            required
          />
        </div>
        <div class="grid-2-g grid-12 column">
          Logradouro
          <br />
          <input
            type="text"
            class="readonly"
            readonly
            v-model="job.logradouro"
          />
        </div>
        <div class="grid-2-g grid-12 column">
          Número
          <br />
          <input v-model="job.numero" required />
        </div>
        <div class="grid-2-g grid-12 column">
          Cidade
          <br />
          <input type="text" class="readonly" readonly :value="job.cidade" />
        </div>
        <div class="grid-2-g grid-12 column">
          Bairro
          <br />
          <input type="text" class="readonly" readonly :value="job.bairro" />
        </div>
        <div class="grid-2-g grid-12 column">
          Estado
          <br />
          <input type="text" class="readonly" readonly v-model="job.estado" />
        </div>
        <div class="grid-2-g grid-12 column">
          Complemento
          <br />
          <input type="text" v-model="job.complemento" />
        </div>
      </div>
    </div>

    <div class="data column label">
      <div class="sla">Dados do contato</div>
      <div class="row column-s">
        <div class="grid-3-g grid-12 column">
          Nome
          <br />
          <input type="text" v-model="job.nome_contato" />
        </div>
        <div class="grid-3-g grid-12 column">
          Email
          <br />
          <input type="email" v-model="job.email_contato" />
        </div>
        <div class="grid-3-g grid-12 column">
          Telefone
          <br />
          <input
            type="text"
            v-model="job.celular_contato"
            v-mask="'(##) #####-####'"
          />
        </div>
      </div>
    </div>

    <div class="grid-12 column label">
      <div class="sla">Descrição do problema</div>

      <div class="row column-s">
        <div class="grid-6 grid-12-s column label">
          <br />
          <label>
            Descrição Problema
            <i class="fa fa-question-circle font-13 tip">
              <div>
                Descreva em detalhes o seu problema. Não informe aqui dados
                sensíveis.
              </div>
            </i>
          </label>
          <textarea class="textarea" v-model="job.problema" required></textarea>
        </div>
        <div class="grid-6 grid-12-s column label">
          <br />
          <label>
            Dados Sensíveis
            <i class="fa fa-question-circle font-13 tip">
              <div>
                Informe aqui dados sensíveis como contatos, endereços, senhas,
                nomes, telefones, etc.
              </div>
            </i>
          </label>
          <textarea class="textarea" v-model="job.dado_sensivel"></textarea>
        </div>
      </div>
    </div>

    <div class="buttons-2 row column-s align-center">
      <div class="grid-4 grid-12-s hide-s">
        <Button type="button" layout="white-m-gray" @click="router.back()">
          <i class="fa fa-arrow-left"></i> Voltar
        </Button>
      </div>
      <div class="row justify-end align-center buttons grid-12-s grid-8">
        <Button layout="green-go" :loader="send">Criar</Button>
        <Button layout="green-go detail" :loader="send" @click="detail = true"
          >Criar e Detalhar</Button
        >
      </div>
    </div>
  </form>
</template>

<script>
import Vue from "vue";
import { VueMaskDirective } from "v-mask";
Vue.directive("mask", VueMaskDirective);

import { mapActions, mapGetters, mapMutations } from "vuex";
import Button from "@/components/Button";
import AutoComplete from "@/components/AutoComplete";
import Router from "@/router";

export default {
  name: "NewJob",
  components: { Button, AutoComplete },
  data() {
    return {
      send: false,
      dh_agendamento_cliente_data: "",
      dh_agendamento_cliente_hora: "",
      job: {
        urgencia_atendimento: "",
        dh_agendamento_cliente: "",
        cep: "",
        bairro: "",
        celular_contato: "",
        cidade: "",
        codigo_chamado_cliente: "",
        codigo_duplicado: false,
        codigo_venda: null,
        complemento: "",
        email_contato: "",
        estado: "",
        forma_atendimento: null,
        id_cliente: 1,
        id_projeto: null,
        latitude: null,
        longitude: null,
        logradouro: "",
        motivo_codigo_duplicado: "",
        nome_contato: null,
        nome_local_atendimento: "",
        numero: "",
        problema: "",
        dado_sensivel: "",
      },
      detail: false,
      router: Router,
    };
  },
  methods: {
    ...mapActions("admin", ["LOAD_CLIENTS", "TAKE_JOB"]),
    ...mapActions("general", ["LOAD_CEP"]),
    ...mapActions("client", ["CLIENT_COD_VERIFY", "CREATE_JOB"]),
    ...mapMutations("general", ["SET_STATUS"]),

    verify_client_cod() {
      this.CLIENT_COD_VERIFY({
        id_client: this.job.id_cliente,
        id_call: this.job.codigo_chamado_cliente,
      }).then((r) => (this.job.codigo_duplicado = r && r.data ? true : false));
    },
    cep() {
      if (this.job.cep.length > 9)
        this.LOAD_CEP(this.job.cep.replace(".", "").replace("-", "")).then(
          (r) => {
            if (r && r.logradouro)
              this.job = {
                ...this.job,
                logradouro: r.logradouro,
                bairro: r.bairro,
                cidade: r.localidade,
                estado: r.uf,
              };
            else alert("Você parece estar sem conexão");
          }
        );
    },
    save() {
      event.preventDefault();
      this.send = true;
      this.job.cep = this.job.cep.replace(".", "").replace("-", "");
      this.job.dh_agendamento_cliente =
        this.dh_agendamento_cliente_data +
        " " +
        this.dh_agendamento_cliente_hora;
      this.job.celular_contato = this.job.celular_contato
        .replace("(", "")
        .replace(")", "")
        .replace("-", "")
        .replace(/ /g, "");
      this.geo();
    },
    geo() {
      if (
        !this.job.cep ||
        !this.job.numero ||
        !this.job.logradouro ||
        !this.job.bairro ||
        !this.job.cidade ||
        !this.job.estado
      )
        return;
      this.$gmapApiPromiseLazy()
        .then(() => {
          // eslint-disable-next-line no-undef
          var geocoder = new google.maps.Geocoder();
          var endereco =
            this.job.logradouro +
            " " +
            this.job.numero +
            " " +
            this.job.bairro +
            " " +
            this.job.cidade +
            " " +
            this.job.estado;
          var self = this;
          var job = this.job;
          geocoder.geocode({ address: endereco }, function (results, status) {
            // eslint-disable-next-line no-undef
            if (status == google.maps.GeocoderStatus.OK) {
              job.latitude = results[0].geometry.location.lat();
              job.longitude = results[0].geometry.location.lng();
              self.CREATE_JOB(job, self.detail).then((r) => {
                self.send = false;
                if (r.status === 201) {
                  self.job = {};
                  self.SET_STATUS({
                    text: "Job cadastrado com sucesso",
                    color: "green",
                  });

                  if (self.detail)
                    self
                      .TAKE_JOB({
                        idJob: r.data.id,
                        idAdmin: self.user.id_funcionario,
                      })
                      .then(() =>
                        self.router.push("/funcionario/job/" + r.data.id)
                      );
                }
              });
            }
          });
        })
        .catch((e) => {
          console.error("[Job] Falha no Google Maps ao gravar o Job (NewJobAdmin):", e);
          alert("Você parece estar sem conexão");
        });
    },
  },
  computed: {
    ...mapGetters("user", ["user", "perfil"]),
    ...mapGetters("admin", ["clients"]),
  },
  mounted() {
    this.LOAD_CLIENTS();
    this.$parent.$parent.$children[0].changeMenu("newJob");
  },
};
</script>

<style lang="scss" scoped>
@use "@/assets/scss/vars.scss" as *;
.new {
  padding: 32px 35px;
  box-shadow: $shadow;
  background: $white;
  border-radius: 23px;
  div {
    padding: 0px 5px;
  }
  .textarea {
    background: $white !important;
  }
  input,
  select {
    /* width: 90%; */
    height: 56px;
    background: $white;
    border: 1px solid $white-6;
    font-size: 14px;
    color: $gray-5;
    border-radius: 5px;
    letter-spacing: 0.5px;
    padding: 0px 7px;
    margin-top: 10px;
  }

  .title {
    font-size: 26px;
    font-weight: 400;
    margin-bottom: 50px;
    
    @media (max-width: $large) {
      padding-bottom: 15px;
    }
  }
  .sla {
    font-size: 20px;
    font-weight: 400;
    margin-bottom: 30px;
    color: $client-2;
  }
  .data {
    margin-bottom: 50px;
    .grid-12 {
      @media (max-width: $large) {
        margin-top: 27px;
      }
    }
  }
  .label {
    color: $gray-6;
    font-size: 15px;
    font-weight: 300;
    strong {
      color: $gray-7;
      text-transjob: capitalize;
    }
  }
  .detail {
    margin-left: 10px;
    background: $blue-1;
  }
  .buttons-2 {
    padding-top: 35px;
    @media (max-width: $small) {
      margin-top: 27px;
      margin-bottom: 10px;
      button {
        margin-bottom: 20px;
      }
    }
  }
}
</style>
